import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Te da vergüenza cuando viene gente y preferís que no presten demasiada atención a ciertos espacios de tu casa.', 'Te comparás con otras casas y sentís que la tuya se ve vieja, apagada y lejos de lo que te gustaría mostrar.', 'Convivís con manchas, juntas oscuras o muebles gastados que ya ni querés mirar.', 'Postergás el cambio porque no querés polvo, desorden y albañiles invadiendo tu casa.', 'Te paraliza la idea de gastar una fortuna en una obra y que encima el resultado no esté a la altura.'];
export function PainPoints() {
  return <section className="py-8 md:py-12 px-4 md:px-6 lg:px-8 bg-black" data-id="element-136">
      <div className="max-w-3xl mx-auto" data-id="element-137">
        <div className="text-center mb-5" data-id="element-138">
          <h2 className="text-xl md:text-2xl font-black text-white tracking-tight" data-id="element-139">
            Esto Es Exactamente Lo Que Te Está Pasando…
          </h2>
        </div>

        <div className="flex flex-col gap-2" data-id="element-140">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="bg-white/5 backdrop-blur-sm p-3 rounded-lg border-l-4 border-orange flex items-start gap-2.5" data-id="element-141">
              <span className="text-sm flex-shrink-0 mt-0.5" data-id="element-142">❌</span>
              <p className="text-white/90 font-medium leading-snug text-sm" data-id="element-143">
                {point}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}